import { getRoot, types } from 'mobx-state-tree';
import { createThunk, model, Model } from 'mst-collection';
import { formatDistanceToNowStrict, parseJSON } from 'date-fns';

import { Api, NotificationTypeEnum } from '@api';
import { enumerationNumber } from '../types';
import type { RootModelType } from '../RootModel';

export class Notification extends Model({
  id: types.identifierNumber,
  type: enumerationNumber([
    NotificationTypeEnum.NewMessage,
    NotificationTypeEnum.NewMention,
    NotificationTypeEnum.NewTrack,
    NotificationTypeEnum.NewVideo,
    NotificationTypeEnum.SubBefore,
    NotificationTypeEnum.SubDay,
  ]),
  url: types.string,
  isNew: types.boolean,
  message: types.string,
  objectId: types.maybe(types.number),
  sendTime: types.string,
}) {
  get formattedSendTime() {
    return formatDistanceToNowStrict(parseJSON(this.sendTime), {
      addSuffix: true,
    });
  }

  setIsNew(value: boolean) {
    this.isNew = value;
  }

  markAsRead = createThunk(() => {
    return async function markAsRead(this: Notification) {
      this.setIsNew(false);
      getRoot<RootModelType>(this).notifications.decreaseNewCount();
      await Api.Notifications.setAsRead({ id: this.id });
    };
  });
}

export const NotificationModel = model(Notification);
